export default __webpack_public_path__ + "static/media/wine_sunset_cropped.40833da3.jpg";